import API from "../Common/Endpoint/serviceConstrants";
import axiosIntegration from "../Common/Axios/axiosIntegration";
export const callSendSmsApi = async (payload) => {
  const { ClientCode,partnerCode, ...sanitizedPayload } = payload;
  const { data = {} } = await axiosIntegration.post(
    API.sendSms,
    sanitizedPayload,
    {
      headers: {
        ClientCode: ClientCode,
        partnerCode:partnerCode,
      },
    }
  );
  return data;
};
